<template>
  <v-app>
    <v-navigation-drawer app :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer">
      <v-list dense nav>
          <v-list-item>
          <v-list-item-icon>
            <v-icon></v-icon>
          </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{navMenuTitle}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>


        <v-list-item v-for="item in navDrawerItems" :key="item.title" link :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark :clipped-left="$vuetify.breakpoint.lgAndUp">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="d-flex align-center">
        <v-img
          alt="1st Logo"
          class="shrink mr-2"
          contain
          src="@/assets/1st_wt.png"
          transition="scale-transition"
          width="40"
        />

        <h3>Hub Management Console</h3>
      </div>

      <v-spacer></v-spacer>
      <h4>{{hubEnvLabel}}</h4>
      <v-spacer></v-spacer>

      <router-link to="/login">
        <v-btn text color="white">
          <v-avatar color="red" size="36">
            <img v-if="profilePicture && showProfilePicture" :src="profilePicture" @error="handleBrokenProfileImage()" />
            <span v-else class="white--text headline">{{ profileInitials }}</span>
          </v-avatar>
        </v-btn>
      </router-link>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";

export default {
  async created() {
      const thisPath = this.$route.fullPath.toLowerCase();

      if (
        thisPath.startsWith("/pmsconnector") &&
        !thisPath.startsWith("/pmsconnectors")
      ) {
        this.navDrawerMode = "pmsconn";
        this.currentPmsConnSub = this.$route.params.sub ?? "";
      } else {
        this.currentPmsConnSub = "";
        this.navDrawerMode = "main";
      }


    await this.getUser();
    this.profileInitials = `${this.user.attributes["given_name"].charAt(
      0
    )}${this.user.attributes["family_name"].charAt(0)}`;
    this.profilePicture = this.user.attributes?.picture;
  },
  data: () => {
    return {
      drawer: null,
      navDrawerMode: "main",
      mainNavDrawerItems: [
        { title: "Home", icon: "mdi-home", to: "/" },
        {
          title: "PMS Connectors",
          icon: "mdi-lan-connect",
          to: "pmsConnectors",
        },
      ],
      currentPmsConnSub: "",
      user: {},
      profileInitials: "",
      profilePicture: "",
      isAuthenticated: false,
      showProfilePicture: true,
      hubEnvLabel: process.env.VUE_APP_ENV_LABEL,
      HUB_APPSYNC_ENDPOINT: process.env.VUE_APP_HUB_APPSYNC_ENDPOINT,
      HUB_USER_POOL_CLIENT_ID: process.env.VUE_APP_HUB_USER_POOL_CLIENT_ID,
      HUB_USER_POOL_ID: process.env.VUE_APP_HUB_USER_POOL_ID,
      welcome: `My Test App ${
        process.env.VUE_APP_ENV_LABEL
          ? " - " + process.env.VUE_APP_ENV_LABEL
          : ""
      }`,
    };
  },
  watch: {
    $route: function (r) {
      const thisPath = r.fullPath.toLowerCase();

      if (
        thisPath.startsWith("/pmsconnector") &&
        !thisPath.startsWith("/pmsconnectors")
      ) {
        this.navDrawerMode = "pmsconn";
        this.currentPmsConnSub = r.params.sub ?? "";
      } else {
        this.currentPmsConnSub = "";
        this.navDrawerMode = "main";
      }
    },
  },
  computed: {
    navMenuTitle: function() {
      return this.navDrawerMode == "pmsconn" ? "PMS Connector Menu" : "Main Menu";
    },
    navDrawerItems: function () {
      return this.navDrawerMode == "pmsconn"
        ? this.pmsConnNavDrawerItems
        : this.mainNavDrawerItems;
    },
    pmsConnNavDrawerItems: function () {

      const sub = "fish";//this.$router.currentRoute.params.sub ?? "";
      return [
          { title: "Back", to: "/pmsConnectors", icon: "mdi-arrow-left" },
          { title: "Details", to: `/pmsConnector/${this.currentPmsConnSub}`, icon: "mdi-information-outline" },
          { title: "Products", to: `/pmsConnector/${this.currentPmsConnSub}/products`, icon: " mdi-package-variant" },
          { title: "Availability", to: `/pmsConnector/${this.currentPmsConnSub}/availability`, icon: "mdi-calendar-range" },
          { title: "Heartbeats", to: `/pmsConnector/${this.currentPmsConnSub}/heartbeats`, icon: "mdi-heart" },
          { title: "Remote Control", to: `/pmsConnector/${this.currentPmsConnSub}/remoteControl`, icon: "mdi-remote" },
          { title: "Logs", to: `/pmsConnector/${this.currentPmsConnSub}/logs`, icon: "mdi-book-open-variant" },
          { title: "PMS Info", to: `/pmsConnector/${this.currentPmsConnSub}/pmsInfo`, icon: "mdi-clipboard-text" },
          { title: "Advanced Setup", to: `/pmsConnector/${this.currentPmsConnSub}/setup`, icon: "mdi-cog" },
        ];
    },
  },
  methods: {
    getUser: async function () {
      {
        try {
          const user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
          if (user && user.signInUserSession) {
            //console.log("getUser got user", user);
            this.user = user;
            this.isAuthenticated = true;
          } else {
            console.log("getUser user invalid");
            this.user = user;
            this.isAuthenticated = false;
          }
        } catch (err) {
          console.log("getUser err", err);
          this.user = {};
          this.isAuthenticated = false;
        }
      }
    },
    handleBrokenProfileImage: function() {
      this.showProfilePicture = false;
    },
  },
};
</script>
